import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createCreditLine,
  deleteCreditLine,
  getCreditLineById,
  getCreditLines,
  updateCreditLine,
  validateCreditLineHierarchy,
} from "../../../services/creditLineService";

export const getCreditLinesThunk = createAsyncThunk(
  "creditLine/getAll",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await getCreditLines(userId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const getCreditLineByIdThunk = createAsyncThunk(
  "creditLine/getById",
  async (creditLineId, { rejectWithValue }) => {
    try {
      const response = await getCreditLineById(creditLineId);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const createCreditLineThunk = createAsyncThunk(
  "creditLine/create",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createCreditLine(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const updateCreditLineThunk = createAsyncThunk(
  "creditLine/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await updateCreditLine(id, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const deleteCreditLineThunk = createAsyncThunk(
  "creditLine/delete",
  async (creditLineId, { rejectWithValue }) => {
    try {
      const response = await deleteCreditLine(creditLineId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

// Creditline Heirarchy  Validation api

// Validate CreditLine Hierarchy

export const validateCreditLineHierarchyThunk = createAsyncThunk(
  "creditLine/validateHierarchy",
  async (cid, { rejectWithValue }) => {
    try {
      const response = await validateCreditLineHierarchy(cid);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

